import { useMemo } from 'react';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import BonusIndicator from 'modules/bonus-indicator/index.js';
import BonusIndicatorTypes from 'modules/bonus-indicator/types.js';
import { useSelector } from 'react-redux';
const { selectAllowEarlyPayout } = MojitoServices.UserInfo.selectors;

const { Text, FlexPane } = MojitoPresentation.Components;

const EarlyPayoutOffers = props => {
    const {
        eventGroup,
        mojitoTools: { config, stringResolver },
    } = props;
    const allowEarlyPayout = useSelector(selectAllowEarlyPayout);
    const bonusInfo = useMemo(
        () => ({ rules: eventGroup?.earlyPayout?.rules }),
        [eventGroup?.earlyPayout]
    );

    if (!eventGroup.earlyPayout || !allowEarlyPayout) {
        return null;
    }

    return (
        <FlexPane config={config.offersContainer}>
            <Text config={config.offersText}>
                {stringResolver.resolveString('$EARLY_PAYOUT_OFFERS.OFFERS')}
            </Text>
            <BonusIndicator
                class="ta-earlyPayoutIndicator"
                config={config.earlyPayoutIndicator}
                bonusType={BonusIndicatorTypes.TYPES.EARLY_PAYOUT}
                bonusInfo={bonusInfo}
                isAwarded={eventGroup.earlyPayout.awarded}
            />
        </FlexPane>
    );
};

export default EarlyPayoutOffers;
